import React, { useRef, useState } from "react";
import { Card } from "react-bootstrap";
import { MdDelete, MdVisibility } from "react-icons/md";
import { toast } from "react-toastify";
import * as apicall from "../../components/Apicall";
import Loader from "../../components/Loader";

const Documents = () => {
  const tradeRef = useRef();
  const regRef = useRef();
  const taxRef = useRef();
  const userDetails = JSON.parse(localStorage.getItem("user_details"));
const [loading,setLoading]=useState();
  const [files, setFiles] = useState({
    tradeLicense: null,
    companyRegistration: null,
    taxCertificate: null,
  });

const [previewFields, setPreviewFields] = useState({});

const handleUpload = (e, field) => {
  const file = e.target.files[0];
  if (!file) return;

  const fileData = {
    fileType: file.type,
    fileName: file.name,
    fileActual: file,    
    preview: ""
  };

  const reader = new FileReader();
  reader.onload = () => {
    fileData.preview = reader.result;
    setFiles((prev) => ({ ...prev, [field]: fileData }));
  };

  reader.readAsDataURL(file);
};
const id = userDetails.id
const uploadDocuments = async () => {
  const payload = {
    trade_license: null,
    company_registration: null,
    tax_certificate: null,
  };

  const convertToBase64 = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () =>
        resolve({
          name: file.name,
          type: file.type,
          data: reader.result.split(",")[1], // Only BASE64 part
        });
      reader.readAsDataURL(file);
    });

  if (files.tradeLicense?.fileActual) {
    payload.trade_license = await convertToBase64(files.tradeLicense.fileActual);
  }

  if (files.companyRegistration?.fileActual) {
    payload.company_registration = await convertToBase64(files.companyRegistration.fileActual);
  }

  if (files.taxCertificate?.fileActual) {
    payload.tax_certificate = await convertToBase64(files.taxCertificate.fileActual);
  }

  try {
    setLoading(true)
    const res = await apicall.post(payload, `uploadDocuments/${id}`);
    if (res.success) {
      toast.success("Updated Successfully");
    }
  } catch (error) {
    console.error("Upload error", error);
  }finally{
        setLoading(false)

  }
};


  const handleDelete = (field) => {
    setFiles((prev) => ({ ...prev, [field]: null }));
    if (previewFields === field) setPreviewFields(null);
  };

  const renderRow = (label, field, inputRef) => (
    <div className="mb-4">
      <label className="fw-semibold">{label}</label>

      <div className="d-flex align-items-center mt-2">

        {/* FILE NAME BOX */}
        <div
          className="form-control d-flex justify-content-between align-items-center"
          style={{ width: "350px", background: "#f8f9fa" }}
        >
          <span className="text-dark">
            {files[field]?.fileName || "No file uploaded"}
          </span>

          {files[field] && (
            <div className="d-flex align-items-center">
              {/* EYE ICON */}
             <MdVisibility
  size={20}
  className="text-primary me-2"
  style={{ cursor: "pointer" }}
  onClick={() =>
    setPreviewFields(prev => ({
      ...prev,
      [field]: !prev[field]
    }))
  }
/>


              {/* DELETE ICON */}
              <MdDelete
                size={20}
                className="text-danger"
                style={{ cursor: "pointer" }}
                onClick={() => handleDelete(field)}
              />
            </div>
          )}
        </div>

        {/* UPLOAD BUTTON */}
        <button
          type="button"
          className="btn btn-outline-secondary ms-3"
          onClick={() => inputRef.current.click()}
        >
          Upload
        </button>

        <input
          type="file"
          accept="image/*,.pdf,.doc,.docx"
          ref={inputRef}
          style={{ display: "none" }}
          onChange={(e) => handleUpload(e, field)}
        />
      </div>

     {previewFields[field] &&
  files[field] &&
  files[field].fileType.startsWith("image/") && (
    <div className="mt-3">
      <img
        src={files[field].preview}
        alt="Preview"
        style={{
          width: "100px",
          height: "100px",
          borderRadius: "8px",
          border: "1px solid #ddd",
        }}
      />
    </div>
)}

    </div>
  );

  return (
    <Card className="p-4">
      <h5 >Documents</h5>
      <p className="text-muted mb-4">Manage your company documents</p>

      {renderRow("Trade License", "tradeLicense", tradeRef)}
      {renderRow("Company Registration", "companyRegistration", regRef)}
      {renderRow("Tax Certificate", "taxCertificate", taxRef)}
      
      <button 
  className="btn btn-danger mt-3"
  onClick={uploadDocuments}
>
  {loading ? <Loader /> : " Save Documents"}
 
</button>
    </Card>
  );
};

export default Documents;
